// src/components/StepByStepGuide.js
import React from 'react';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';

const StepByStepGuide = ({ title, subtitle, steps }) => {
  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-dark-text-primary sm:text-4xl">
            {title}
          </h2>
          <p className="mt-4 text-lg text-dark-text-secondary">{subtitle}</p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl">
          <ol className="space-y-12">
            {steps.map((step, index) => (
              <li key={step.title} className="flex gap-x-6">
                <div className="relative flex h-16 w-16 flex-none items-center justify-center">
                  <div className="absolute inset-0 bg-dark-card/40 rounded-2xl border border-white/10"></div>
                  <IoCheckmarkCircleOutline className="relative h-8 w-8 text-dark-accent-start" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-dark-text-primary">{step.title}</h3>
                  <p className="mt-2 text-base text-dark-text-secondary">{step.description}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default StepByStepGuide;